var path = 'app/admin/monitoring/visitors/monitoringVisitor.html';
var html = "<ui-view></ui-view>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;